import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Link } from 'components';

// Styles
import classNames from 'classnames/bind';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Options = ({ productParameters }) => (
  <ul className={cx('options-list')}>
    {productParameters?.map((option) => (
      <li key={option?.label} className={cx('options-list__item')}>
        {(option?.value && option?.value.indexOf('http') > -1)
          ? (
            <Link
              href={option.value}
              rel="noopener noreferrer"
              target="_blank"
            >
              {option?.label}
            </Link>
          ) : (
            <>
              {option?.label && (
                <span className={cx('options-list__item-label')}>
                  {option.label}
                </span>
              )}
              {option?.value && (
                <span>
                  {option.value}
                </span>
              )}
            </>
          )}
      </li>
    ))}
  </ul>
);

Options.propTypes = {
  productParameters: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default Options;
